import type { Review as IReview } from '@bulknutrients/bulk-shared-lib/interfaces/Review';
import { SkeletonText } from '@components/Placeholders/Skeleton';
import Image from 'next/image';
import Link from 'next/link';
import { StarRating } from '../Product/StarRating';

export function Review({
  review,
  pending,
}: {
  review: IReview;
  pending?: boolean;
}) {
  return (
    <div>
      <h3 className="text-2xl italic">
        {review.review_summary}
        {pending ? (
          <span className="text-grey-mid italic ml-2">(pending)</span>
        ) : (
          ''
        )}
      </h3>
      <div className="flex justify-between items-center border-b-1 border-t-1 border-grey-dark my-1 py-1">
        <div>
          <StarRating rating={review.stars} />
          {review.product_description ? (
            <span className="text-xs">{review.product_description}</span>
          ) : null}
        </div>
        <p className="text-xs flex flex-col py-0.5 text-right">
          {
            <span>
              {review.display_name}{' '}
              {review.created_at ? (
                <>
                  on {new Date(review.created_at).toLocaleDateString('en-AU')}
                </>
              ) : null}
            </span>
          }
          <span className="italic">Verified buyer</span>
        </p>
      </div>
      <p>{review.review_body}</p>
      {review.image_thumb_0 && (
        <div className="h-[150px] w-[200px] relative">
          <Link href={review.image_0 ?? review.image_thumb_0} target="_blank">
            <Image
              src={review.image_thumb_0}
              alt={review.review_summary}
              fill
              objectFit="contain"
              className="mt-2"
            />
          </Link>
        </div>
      )}
      {review.customer_service_reply && (
        <div className="-ml2 mb-0 mr-0 mt-8 flex flex-col border-b-0 border-l-5 border-r-0 border-t-0 border-solid border-l-grey-mid pb-0.5 pl-2.5 pr-5 pt-0.5 font-normal">
          <span className="text-grey-mid">Bulk Nutrients replied:</span>
          <span className="italic ml-3">{review.customer_service_reply}</span>
        </div>
      )}
    </div>
  );
}

export function ReviewSkeleton() {
  return (
    <div>
      <SkeletonText heightPixels={36} textHeightPixels={28} />
      <div className="flex justify-between items-center border-b-1 border-t-1 border-grey-dark my-1 py-1">
        <SkeletonText heightPixels={16} textClasses="min-w-[100px]" />

        <SkeletonText
          heightPixels={24}
          textHeightPixels={10}
          textClasses="min-w-[110px]"
        />
      </div>
      <SkeletonText heightPixels={40} textClasses="text-xs" />
    </div>
  );
}
